export default __webpack_public_path__ + "a8f4ec2f31eb78e217de092fe6010955.jpg";